import React from "react";
import TopNavBar from "../../common/Header/TopNavBar";
import Footer from "../../common/Footer/Footer";
import swhTitle from "../../images/titile.png";
import html from "../../images/html5.png";
import { FaCheck } from "react-icons/fa";
import Track1Detail from "./TrackDetailComponent/Track1Detail";


function TrackDetail() {
  return (
    <>
      <TopNavBar />

      <div className="containerS training p-2 td-container">
        <img
          src={swhTitle}
          alt="project"
          className="mt-5 w-25 img-fluid swhTitle"
        />
        {/* <Track1Detail /> */}
        <h2 className="text-center mt-4 detail-heading">HTML</h2>
        <div className="row ">
          <div className="col-7 p-3 mx-5 text-white">
            <h3 className="m-3">Hyper Text Markup language</h3>
            <p className="mt-4">
              Creating a detailed course information page like Udemy's involves
              numerous elements and styles, which can be quite extensive. While
              I can provide you with a basic example, please note that
              replicating the full functionality and design of a complex
              platform like Udemy would require more advanced coding and design
              skills.
            </p>
          </div>
          <div className="col-3 mx-5 sticky-html-image">
            <img src={html} alt="project" className="card-img img-fluid" />
          </div>
        </div>
      </div>
      <div className="col-10 l-outcome mx-5 p-1">
        <h3 className="text-center m-3">Learning outcome</h3>
        <ul className="row list-unstyled">
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
          <li className="col-6 d-flex mt-0">
            <FaCheck className="fa-solid fa-check mx-2" />
            <p>
              Become a modern and confident HTML and CSS developer, no prior
              knowledge needed!
            </p>
          </li>
        </ul>
      </div>
      <h3 className="mx-5">HTML Course Contents</h3>
      <div className="col-8 l-content mx-5 p-1">
        <div className="accordion" id="courseAccordion">
          <div className="accordion-item ">
            <h2 className="accordion-header" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Introduction to HTML
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#courseAccordion"
            >
              <div className="accordion-body">
                <p>Understanding the basics of HTML.</p>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                HTML Elements and Tags
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#courseAccordion"
            >
              <div className="accordion-body">
                <p>Exploring various HTML elements and their usage.</p>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="headingThree">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                Building a Web Page
              </button>
            </h2>
            <div
              id="collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="headingThree"
              data-bs-parent="#courseAccordion"
            >
              <div className="accordion-body">
                <p>Creating a complete web page using HTML.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default TrackDetail;
